import initialState from '../../initialState';
import { EventPanelActions } from '../../constants';

const reducer = (state = initialState.EventPanel, action = {}) => {
  switch (action.type) {
    case EventPanelActions.UPDATE_EVENT_CONTENT:
      return { ...state, eventContent: action.eventContent };
    default:
      return state;
  }
};
export default reducer;
